module.exports = __webpack_public_path__ + "fonts/Gotham-LightItalic.8dcf7a10.otf";